import { ref as c, watch as I, nextTick as j, onMounted as R, createElementBlock as p, openBlock as v, createCommentVNode as y, withModifiers as $, normalizeClass as N, createVNode as B, Fragment as A, renderList as z, withDirectives as P, createBlock as O, resolveDynamicComponent as U, mergeProps as W, vShow as G, toDisplayString as H } from "vue";
import { themeProp as J } from "../../composables/useTheme.js";
import K from "../tooltip/tooltip.vue.js";
import { FORM_SUBMIT_COLOR as x, FORM_SUBMIT_STATE as s } from "./constants.js";
import Q from "./form-attachment/form-attachment.vue.js";
import X from "./form-button/form-button.vue.js";
import Y from "./form-checkbox/form-checkbox.vue.js";
import Z from "./form-field/form-field.vue.js";
import ee from "./form-select-box/form-select-box.vue.js";
import te from "./form-textarea/form-textarea.vue.js";
import { isValidFormField as ae } from "./validation.js";
/* empty css          */
const he = /* @__PURE__ */ Object.assign({
  name: "DsForm"
}, {
  __name: "form",
  props: {
    ...J,
    /**
     * Fields to populate form with.
     * Must contain: 'name', 'label', 'type', 'required', 'visible'
     * Optionally custom validation can be passed through a `validate` function or standard 'required'
     * Other optional parameters are: 'initialValue', 'errorMessage', and 'labels', 'placeholder' and 'options' for the select component
     */
    formId: {
      type: String,
      default: () => Math.random() + ""
    },
    fields: {
      type: Array,
      required: !0,
      validator: (r) => r.every((d) => ["name", "label", "type", "required", "visible"].every((h) => h in d))
    },
    submitColor: {
      type: String,
      default: x.green,
      validator(r) {
        return [x.green, x.black].includes(r);
      }
    },
    /**
     * State of form submit
     * Possible options are: 'start', 'loading', 'success', 'fail' and 'disabled'
     * Constants are available from '../..molecules/form'
     */
    submitState: {
      type: String,
      required: !0,
      validator: (r) => [
        s.start,
        s.loading,
        s.success,
        s.fail,
        s.disabled
      ].indexOf(r) > -1
    },
    /**
     * Label to show on form submit button
     */
    submitLabel: {
      type: String,
      required: !0
    },
    /**
     * Label to show when form submission succeeds
     */
    submitSuccessLabel: {
      type: String,
      required: !0
    },
    /**
     * Label to show when form submission fails
     */
    submitFailLabel: {
      type: String,
      required: !0
    }
  },
  emits: ["submit", "change"],
  setup(r, { emit: d }) {
    const h = d, o = r, i = c({}), l = c([]), g = c([]), b = c(null), n = c([]), F = c(/* @__PURE__ */ new Set([])), S = c(o.formId);
    I(
      () => o.formId,
      async (a) => {
        S.value = null, await j(), S.value = a;
      }
    ), I(
      () => o.submitState,
      (a, t) => {
        (t === s.success || a === s.success) && (b.value = {
          label: o.submitSuccessLabel,
          className: "ds-color-green"
        }), (t === s.fail || a === s.fail) && (b.value = {
          label: o.submitFailLabel,
          className: "ds-color-red"
        });
      }
    ), R(() => {
      n.value = o.fields || [];
      const a = n.value.filter((t) => t == null ? void 0 : t.visibilityRules);
      a.length && (F.value = new Set(
        a.map((t) => t.visibilityRules.map((e) => e.subjectFieldName)).flat()
      )), i.value = n.value.reduce((t, e) => (t[e.name] = {
        value: k(e),
        required: (e == null ? void 0 : e.required) ?? !1,
        validate: (e == null ? void 0 : e.validate) ?? !1
      }, t), {}), g.value = _(n.value), n.value.forEach((t) => {
        t.initialValue && w(t, t.initialValue, !0);
      });
    });
    const C = (a) => {
      switch (!0) {
        case a === "select":
          return ee;
        case a === "checkbox":
          return Y;
        case a === "textarea":
          return te;
        case a === "attachment":
          return Q;
        default:
          return Z;
      }
    }, L = (a) => {
      var t;
      return (t = l.value) == null ? void 0 : t.includes(a);
    }, D = () => {
      g.value.forEach((a) => {
        const t = l.value.indexOf(a.name), e = ae(i.value[a.name]);
        !e && t === -1 ? l.value.push(a.name) : e && t !== -1 && l.value.splice(t, 1);
      });
    }, E = () => {
      if (!(o.submitState === s.loading || o.submitState === s.disabled) && (o.submitState !== s.loading && D(), l.value.length === 0)) {
        const a = Object.keys(i.value).reduce((t, e) => (t[e] = i.value[e].value, t), {});
        h("submit", {
          formData: a,
          formFields: n.value
        });
      }
    };
    function k({ type: a, initialValue: t }) {
      return t || (a === "checkbox" ? !1 : "");
    }
    function T(a, t) {
      return n.value.map((e) => {
        var M, q;
        if (!((M = e == null ? void 0 : e.visibilityRules) == null ? void 0 : M.some((f) => f.subjectFieldName === a)))
          return e;
        const V = l.value.indexOf(e.name);
        l.value.splice(V, 1), i.value[e.name].value = k(e);
        const u = (q = e == null ? void 0 : e.visibilityRules) == null ? void 0 : q.find(
          (f) => f.subjectFieldName === a && f.subjectFieldValues.includes(t)
        );
        if (!u)
          return {
            ...e,
            visible: !1
          };
        switch (e.type) {
          case "select":
            return {
              ...e,
              placeholder: u == null ? void 0 : u.label,
              label: u == null ? void 0 : u.label,
              options: u == null ? void 0 : u.options,
              visible: !0
            };
          case "text":
          case "tel":
            return {
              ...e,
              visible: !0
            };
          default:
            return {
              ...e,
              visible: !1
            };
        }
      });
    }
    function _(a) {
      return a.filter((t) => ((t == null ? void 0 : t.required) || (t == null ? void 0 : t.validate)) && (t == null ? void 0 : t.visible));
    }
    function w(a, t, e = !1) {
      const { name: m } = a;
      F.value.size && F.value.has(m) && (n.value = T(m, t), g.value = _(n.value)), i.value[m].value = t, e || h("change", { fieldName: m, fieldValue: t, state: o.submitState });
    }
    return (a, t) => (v(), p("div", null, [
      S.value ? (v(), p("form", {
        key: r.formId,
        method: "post",
        autocomplete: "off",
        novalidate: "",
        class: N(["ds-form", { "ds-form--with-tooltip": r.fields.find((e) => e.infoMessage) }]),
        onSubmit: $(E, ["prevent"])
      }, [
        (v(!0), p(A, null, z(n.value, (e) => (v(), p("div", {
          key: e.name + "-" + r.formId,
          class: "ds-position-relative ds-display-flex ds-align-items-flex-start"
        }, [
          P((v(), O(U(C(e.type)), W({
            "has-error": L(e.name),
            value: i.value[e.name].value,
            theme: a.theme,
            ref_for: !0
          }, e, {
            onValue: (m) => w(e, m)
          }), null, 16, ["has-error", "value", "theme", "onValue"])), [
            [G, e.visible]
          ]),
          e.infoMessage && e.visible ? (v(), O(K, {
            key: 0,
            theme: a.theme,
            description: e.infoMessage,
            class: "ds-form__tooltip"
          }, null, 8, ["theme", "description"])) : y("", !0)
        ]))), 128)),
        B(X, {
          label: r.submitLabel,
          state: r.submitState,
          color: r.submitColor
        }, null, 8, ["label", "state", "color"])
      ], 34)) : y("", !0),
      b.value ? (v(), p("p", {
        key: 1,
        class: N(["ds-text ds-font-weight-bold ds-margin-top-24", b.value.className])
      }, H(b.value.label), 3)) : y("", !0)
    ]));
  }
});
export {
  he as default
};
